import React, { useCallback } from 'react';
import * as Styles from './PlansBanner.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import snappyImagePath from '../../media/snappy-monarx.svg';
import { SelectField, Skeleton, Tooltip } from 'gatorcomponents';


const PlansBanner = ({
  testId = 'plans-banner',
  content,
  onChangePlan,
  plans = [],
  selectedPlan,
  loading = false,
}) => {
  const hasMultiplePlans = plans.length > 1;
  const planLabel = (plan) => {
    const shouldTruncate = plan.shared_hosting_domain.length > 13;
    const stringLength = 10;

    const truncatedDomain = `${shouldTruncate
      ? `${plan.shared_hosting_domain.substring(0, stringLength)}...${plan.shared_hosting_domain.split('.').pop()}`
      : plan.shared_hosting_domain}`;

    return (
      <Tooltip
        content={shouldTruncate ? plan.shared_hosting_domain : ''}
        disabled={!shouldTruncate}
      >
        <div>
          {`${plan.shared_hosting_plan} - ${content.mainDomain} ${truncatedDomain}`}
          {plan.isPro && (
          <Styles.ProBadge>
            {content.proBadgeLabel}
          </Styles.ProBadge>
          )}
        </div>
      </Tooltip>
    );
  };

  const parsedPlans = plans && plans.map(plan => ({
    ...plan,
    label: planLabel(plan),
    value: plan.shared_hosting_id,
  }));

  const handleOnChangePlan = useCallback((plan) => {
    if (onChangePlan) {
      onChangePlan(plan);
    }
  }, [onChangePlan]);

  return (
    <Styles.Wrapper data-testid={testId}>
      <Styles.LogoAdapter>
        <Styles.Image src={snappyImagePath} alt={content.title} />
        <Styles.ContentAdapter>
          <Styles.Title>
            {content.title}
          </Styles.Title>
          <Styles.Description>
            {content.description}
          </Styles.Description>
        </Styles.ContentAdapter>
      </Styles.LogoAdapter>
      {hasMultiplePlans && (
        <Styles.SelectAdapter>
          <Styles.SelectLabel>
            {content.selectPlanLabel}
          </Styles.SelectLabel>

          {loading
            ? <Skeleton height="40px" />
            : (
              <SelectField
                options={parsedPlans}
                onClickSelect={handleOnChangePlan}
                value={loading || !selectedPlan ? '...' : planLabel(selectedPlan)}
              />
            )
          }
        </Styles.SelectAdapter>
      )}
      {!hasMultiplePlans && plans.length > 0 && (
        <Styles.SelectAdapter>
          <Styles.SelectLabel>
            {content.selectPlanLabel}
          </Styles.SelectLabel>
          <Styles.SinglePlanLabel>
            {loading ? '...' : parsedPlans[0].label}
          </Styles.SinglePlanLabel>
        </Styles.SelectAdapter>
      )}
    </Styles.Wrapper>
  );
};

export default withErrorBoundary(PlansBanner, 'PlansBanner');
